// src/views/Settings/account/CredentialsSection.jsx
//
// Las API keys y las conexiones de base de datos son de la cuenta: cambian al
// cambiar de organización. Estaban escondidas en una pestaña de Connections,
// que es donde vive lo que conectas, no lo que te identifica ante la API.
//
// La vista sigue montándose desde `views/Settings/SettingsView.jsx`, cuyo
// nombre todavía miente: es la vista de Credentials. Falta moverla acá.
import React from 'react';
import CredentialsView from '../SettingsView';

export default function CredentialsSection() {
  return <CredentialsView />;
}
